import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabSelected: "liveScheduled",
  rowsTileToggleValue: "rows",

  showResetButton: false,
  sortBy: {
    sortKey: "notification_id",
    reverse: true,
  },
  expiredNotificationsFetched: false,

  filter: {
    queryKeys: [
      "notification_id",
      "script_value",
      "script_type",
      "status",
      "title",
      "message",
      "message_type",
    ],
    startDateTime: "",
    stopDateTime: "",
    searchValue: "",
    idKey: "notification_id",
  },
};

const notificationAllViewSlice = createSlice({
  name: "notificationAllView",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("SEARCH_TABLE_VALUES", (state, action) => {
        state.filter.searchValue = action.searchValue;
        state.showResetButton =
          state.showResetButton || action.searchValue !== "";
      })
      .addCase("CLICK_TAB", (state, action) => {
        state.tabSelected = action.status;
        state.filter = initialState.filter;
        state.showResetButton = false;
      })
      .addCase("SET_TABLE_VIEW", (state, action) => {
        state.rowsTileToggleValue = action.view;
      })
      .addCase("SET_SORT_PARAM", (state, action) => {
        state.sortBy.sortKey = action.sortKey;
        state.sortBy.reverse = action.reverse;
      })
      .addCase("SET_FILTER_DATE", (state, action) => {
        state.showResetButton = true;
        if (action.timeSelected === "start") {
          state.filter.startDateTime = action.dateTime;
        } else {
          state.filter.stopDateTime = action.dateTime;
        }
      })
      .addCase("RESET_FILTER_ALL", (state) => {
        state.filter = initialState.filter;
        state.showResetButton = false;
      })
      .addCase("OPEN_IMAGE_UPLOADED_CONTAINER", (state) => {
        state.setShowImageUpload = true;
      })
      .addCase("CLOSE_IMAGE_UPLOADED_CONTAINER", (state) => {
        state.setShowImageUpload = false;
      })
      .addCase("SET_EXPIRED_NOTIFICATIONS_FETCHED_TO_TRUE", (state) => {
        state.expiredNotificationsFetched = true;
      });
  },
});

export const selectNotificationAllView = (state) => state.notificationAllView;

export default notificationAllViewSlice.reducer;
